import { IS_PRODUCTION } from '@/constants'
import { makeStyles, css, Theme as HeroTheme } from '@conexasaude/hero'
import { SerializedStyles } from '@emotion/react'

type UseGlobalStylesProps = {
  height?: string
}

const useGlobalStyles = (
  theme: HeroTheme,
  props?: UseGlobalStylesProps,
): Record<string, SerializedStyles> => {
  const styles = makeStyles<UseGlobalStylesProps>({
    mainContainer: css`
      display: flex;
      flex-direction: column;
      min-height: 100vh;
      margin-top: ${IS_PRODUCTION ? 0 : '32px'};
      /* mobile viewport bug fix */
      min-height: -webkit-fill-available;
    `,

    typography: () => {
      let styles = ''
      for (let i = 0; i < 6; ++i) {
        const head = 'h' + i
        styles += `
      ${head}{
        font-family: ${theme.typography[head].fontFamily};
        font-size: ${theme.typography[head].fontSize};
        font-weight: ${theme.typography[head].fontWeight};
        line-height: ${theme.typography[head].lineHeight};
        letter-spacing: ${theme.typography[head].letterSpacing};
      }
      `
      }
      return css`
        font-family: ${theme.typography.body1.fontFamily};
        font-size: ${theme.typography.body1.fontSize};
        font-weight: ${theme.typography.body1.fontWeight};
        line-height: ${theme.typography.body1.lineHeight};
        letter-spacing: ${theme.typography.body1.letterSpacing};
        color: ${theme.colors.neutral[900]};
        background: ${theme.colors.extra.background};
        ${styles}
        @keyframes animateLoading {
          0% {
            background-position: -468px 0;
          }
          100% {
            background-position: 468px 0;
          }
        }
        .footer-modal-buttons {
          @media (max-width: 639px) {
            button {
              width: 100%;
            }
          }
        }
      `
    },

    global: (_theme, props) => {
      return css`
        .hero-toast_content {
          > span {
            max-width: 367px;
          }
        }

        .chatlayer-chatbox-wrapper {
          max-height: 540px !important;
          left: 0 !important;
          right: unset !important;
          z-index: 9999;

          @media (max-width: 639px) {
            width: 100vw !important;
            height: ${props?.height || '100vh'} !important;
            max-height: unset !important;
          }

          & > .chatlayer-chatbox-button {
            align-self: flex-start !important;
          }
        }

        .chatlayer-chatbox-button {
          display: none !important;
        }

        .chatlayer-iframe {
          @media (max-width: 639px) {
            position: absolute !important;
            top: 0px !important;
            left: 0px !important;
            right: 0px !important;
            width: 100vw !important;
            z-index: 999 !important;
          }
        }

        .buorg {
          background-color: ${theme.colors.primary[100]} !important;
          border-color: ${theme.colors.primary[900]} !important;
        }

        .buorg-pad {
          padding: 12px 16px !important;
        }

        .buorg-buttons {
          margin-top: 16px;
        }

        #buorgul {
          display: inline-flex !important;
          align-items: center !important;
          height: 55px !important;
          padding-left: 16px !important;
          padding-right: 16px !important;
          border: 2px solid ${theme.colors.primary[500]} !important;
          background-color: ${theme.colors.primary[500]} !important;
          border-radius: 8px !important;
          color: ${theme.colors.common.white} !important;
          box-shadow: none !important;
          box-sizing: border-box !important;

          &:hover {
            background-color: ${theme.colors.primary[700]} !important;
            border-color: ${theme.colors.primary[700]} !important;
          }
        }

        #buorgig {
          display: inline-flex !important;
          align-items: center !important;
          height: 55px !important;
          padding-left: 16px !important;
          padding-right: 16px !important;
          border: 2px solid ${theme.colors.primary[500]} !important;
          background-color: transparent !important;
          border-radius: 8px !important;
          color: ${theme.colors.primary[500]} !important;
          box-shadow: none !important;
          box-sizing: border-box !important;

          &:hover {
            background-color: ${theme.colors.primary[200]} !important;
          }
        }

        #buorgpermanent {
          display: inline-flex !important;
          align-items: center !important;
          height: 55px !important;
          padding-left: 16px !important;
          padding-right: 16px !important;
          border: 2px solid ${theme.colors.primary[500]} !important;
          background-color: ${theme.colors.primary[500]} !important;
          border-radius: 8px !important;
          color: ${theme.colors.common.white} !important;
          box-shadow: none !important;
          box-sizing: border-box !important;

          &:hover {
            background-color: ${theme.colors.primary[700]} !important;
            border-color: ${theme.colors.primary[700]} !important;
          }
        }

        .mantine-DatePicker-monthPickerControl,
        .mantine-DatePicker-yearPickerControl {
          &:hover {
            color: ${theme.colors.primary[500]};
            background-color: ${theme.colors.primary[100]};
          }
        }

        .mantine-DatePicker-monthPickerControlActive,
        .mantine-DatePicker-yearPickerControlActive {
          background-color: ${theme.colors.primary[500]};

          &:hover {
            color: ${theme.colors.common.white};
            background-color: ${theme.colors.primary[700]};
          }
        }

        .mantine-Modal-body {
          .mantine-DatePicker-calendarBase {
            width: auto !important;
          }
        }

        .environmentIdentifier {
          position: fixed;
          top: 0;
          width: 100%;
          z-index: 5;
        }
      `
    },
  })

  return styles(props)
}

export { useGlobalStyles }
